export default __webpack_public_path__ + "img/cfcbc9309414aee8356fc4c11db4c78a.svg";